'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * A simple grid layout.
 */
var Grid = function Grid(_ref) {
  var children = _ref.children,
    spacedOut = _ref.spacedOut;
  var gridClassNames = (0, _classnames2.default)('o-grid', {
    'o-grid--spaced-out-2-cols': spacedOut
  });
  return _react2.default.createElement('div', {
    className: gridClassNames
  }, children);
};
Grid.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Children of the card (See CardBody and CardHeader) */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = Grid;